import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

export function initAppAuthFactory(oAuthService: OAuthService, router: Router): () => Promise<void> {
  return async () => {
    let parts = [];
    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.split('?')[1] : '';
    const urlParams = hash == '' ? new URLSearchParams(window.location.search) : new URLSearchParams(queryString);
    let state = urlParams.get('state');
    parts = state != null ? state.split('&&') : parts;

    // Step 2: Create a map to hold key-value pairs
    const keyValueMap: { [key: string]: string } = {};

    // Step 3: Process parts to extract key=value pairs
    for (let part of parts) {
      if (part.includes('=')) {
        const [key, value] = part.split('=');
        keyValueMap[key] = value;
      }
    }

    let deviceHost = urlParams.get('deviceHost') || parts[0];

    const logOut = urlParams.get('logOut') || '';
    const clientId = urlParams.get('clientId') || environment.auth.clientId;
    const modulus = urlParams.get('modulus') || keyValueMap['modulus'];
    const exponent = urlParams.get('exponent') || keyValueMap['exponent'];

    const authConfig: AuthConfig = {
      issuer: environment.auth.issuer,
      clientId: clientId,
      redirectUri: environment.auth.redirectUri,
      postLogoutRedirectUri: environment.auth.redirectUri,
      responseType: 'code',
      scope: 'openid offline_access',
      showDebugInformation: !environment.production,
      strictDiscoveryDocumentValidation: false,
      oidc: true,
      requestAccessToken: false
    }
    oAuthService.configure(authConfig);

    if (deviceHost) {
      sessionStorage.setItem('deviceHost', deviceHost);
      sessionStorage.setItem('modulus', modulus);
      sessionStorage.setItem('exponent', exponent);
    }

    await oAuthService.loadDiscoveryDocument(environment.auth.discoveryDocument);

    if (window.location.hash.startsWith('#/logout') || logOut === 'true' || state != null) {
      return;
    }

    await oAuthService.tryLogin();

    const postLoginRedirect = sessionStorage.getItem('postLoginRedirect');
    if (oAuthService.hasValidIdToken() && postLoginRedirect) {
    sessionStorage.removeItem('postLoginRedirect');
    router.navigateByUrl(postLoginRedirect, { replaceUrl: true });
}
  };
}